<draggable-container [prefix]="data.prefix">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div>
      <ng-container *ngIf="data.src!==''; then video"></ng-container>
    </div>
    <div>
      <label [for]="data.prefix+'courseImage'" class="d-flex mb-1">
        <input class="form-control" type="text" name="url" placeholder="url del vídeo" [(ngModel)]="tempUrl">
        <button class="btn btn-levelab btn-outline-levelab" (click)="saveUrl()">Guardar</button>
      </label>
    </div>
  </div>
</draggable-container>

<ng-template #video>
  <ng-container *ngIf="isYtVideo(); then ytVideo">
  </ng-container>
  <ng-container *ngIf="isVimeoVideo(); then vimeoVideo">
  </ng-container>
  <ng-container *ngIf="(!isYtVideo() && !isVimeoVideo()); then urlVideo">
  </ng-container>
</ng-template>

<ng-template #ytVideo>
  <youtube-player [videoId]="data.ytVideoId" suggestedQuality="highres" [height]="250" [width]="500" [startSeconds]="4"
    [endSeconds]="8"></youtube-player>
</ng-template>

<ng-template #vimeoVideo>
  <div class="mb-4 text-center">
    <vimeo-player [vimeoVideoId]="data.vimeoVideoId"></vimeo-player>
  </div>
</ng-template>

<ng-template #urlVideo>
  <div class="mb-4 text-center">
    <video controls [height]="250" [width]="500">
      <source [src]="data.src" type="video/mp4">
    </video>
  </div>
</ng-template>